<template>
  <div class="bill-template__fragment">
    <div
      class="bill-template"
      @click="editBill"
      @mouseover="isMouseOver = true"
      @mouseleave="isMouseOver = false"
    >
      <div class="bill-template__icon">
        <svg
          width="45"
          height="44"
          viewBox="0 0 45 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" width="44" height="44" rx="15" fill="#DBFDDE" />
          <path
            d="M21.5489 10.927C21.8483 10.0057 23.1517 10.0057 23.4511 10.9271L25.4187 16.9828C25.5526 17.3948 25.9365 17.6738 26.3697 17.6738H32.7371C33.7058 17.6738 34.1086 18.9134 33.3249 19.4828L28.1736 23.2254C27.8231 23.4801 27.6764 23.9314 27.8103 24.3435L29.7779 30.3992C30.0773 31.3205 29.0228 32.0866 28.2391 31.5172L23.0878 27.7746C22.7373 27.5199 22.2627 27.5199 21.9122 27.7746L16.7609 31.5172C15.9772 32.0866 14.9227 31.3205 15.2221 30.3992L17.1897 24.3435C17.3236 23.9314 17.1769 23.4801 16.8264 23.2254L11.6751 19.4828C10.8914 18.9134 11.2942 17.6738 12.2629 17.6738H18.6303C19.0635 17.6738 19.4474 17.3948 19.5813 16.9828L21.5489 10.927Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="bill-template__name">
        {{ template.TemplateName }}
      </div>
      <div class="bill-template__actions" v-if="isMouseOver" @click.stop>
        <require-access data="bills-template-make_bills" action="read">
          <v-popover
            class="bill-template__actions-item-wrapper"
            trigger="hover"
            offset="10"
            placement="top"
          >
            <div
              class="bill-template__actions-item bill-template__actions-item--copy"
              @click="copyBillLink"
            >
              <svg
                width="12"
                height="16"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.1271 1.97028L1.125 3.5625V11.4407C1.125 12.7868 2.2163 13.8782 3.5625 13.8782L10.0247 13.8784C9.79298 14.5337 9.168 15.0032 8.4333 15.0032H3.5625C1.59499 15.0032 0 13.4082 0 11.4407V3.5625C0 2.82697 0.470587 2.20134 1.1271 1.97028ZM10.3125 0C11.2444 0 12 0.75552 12 1.6875V11.4375C12 12.3695 11.2444 13.125 10.3125 13.125H3.5625C2.63052 13.125 1.875 12.3695 1.875 11.4375V1.6875C1.875 0.75552 2.63052 0 3.5625 0H10.3125ZM10.3125 1.125H3.5625C3.25184 1.125 3 1.37684 3 1.6875V11.4375C3 11.7482 3.25184 12 3.5625 12H10.3125C10.6232 12 10.875 11.7482 10.875 11.4375V1.6875C10.875 1.37684 10.6232 1.125 10.3125 1.125Z"
                  fill="#64748B"
                />
              </svg>
            </div>
            <template v-slot:popover>
              <div class="bill-template__actions-item-hint">
                {{ $t('bill-template.actions.copy-link') }}
              </div>
            </template>
          </v-popover>
        </require-access>
        <require-access data="bills-template-delete_template" action="read">
          <v-popover
            class="bill-template__actions-item-wrapper"
            trigger="hover"
            offset="10"
            placement="top"
          >
            <div
              class="bill-template__actions-item bill-template__actions-item--delete"
              @click="deleteBill"
            >
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.9375 15.675H9.4375C10.1967 15.675 10.9248 15.3734 11.4616 14.8366C11.9984 14.2998 12.3 13.5717 12.3 12.8125V6.0625C12.3 5.90005 12.2355 5.74426 12.1206 5.6294C12.0057 5.51453 11.8499 5.45 11.6875 5.45C11.5251 5.45 11.3693 5.51453 11.2544 5.6294C11.1395 5.74426 11.075 5.90005 11.075 6.0625V12.8125C11.075 13.2468 10.9025 13.6633 10.5954 13.9704C10.2883 14.2775 9.87179 14.45 9.4375 14.45H4.9375C4.50321 14.45 4.0867 14.2775 3.77961 13.9704C3.47252 13.6633 3.3 13.2468 3.3 12.8125V6.0625C3.3 5.90005 3.23547 5.74426 3.1206 5.6294C3.00574 5.51453 2.84995 5.45 2.6875 5.45C2.52505 5.45 2.36926 5.51453 2.2544 5.6294C2.13953 5.74426 2.075 5.90005 2.075 6.0625V12.8125C2.075 13.5717 2.37658 14.2998 2.91341 14.8366C3.45023 15.3734 4.17832 15.675 4.9375 15.675Z"
                  fill="#DD6262"
                  stroke="#DD6262"
                  stroke-width="0.1"
                  stroke-linecap="round"
                />
                <path
                  d="M1.5625 4.425H12.8125C12.9749 4.425 13.1307 4.36047 13.2456 4.2456C13.3605 4.13074 13.425 3.97495 13.425 3.8125C13.425 3.65005 13.3605 3.49426 13.2456 3.3794C13.1307 3.26453 12.9749 3.2 12.8125 3.2H1.5625C1.40005 3.2 1.24426 3.26453 1.1294 3.3794C1.01453 3.49426 0.95 3.65005 0.95 3.8125C0.95 3.97495 1.01453 4.13074 1.1294 4.2456C1.24426 4.36047 1.40005 4.425 1.5625 4.425Z"
                  fill="#DD6262"
                  stroke="#DD6262"
                  stroke-width="0.1"
                  stroke-linecap="round"
                />
                <path
                  d="M4.9375 4.425H9.4375C9.59995 4.425 9.75574 4.36047 9.8706 4.2456C9.98547 4.13074 10.05 3.97495 10.05 3.8125V2.6875C10.05 2.22669 9.86694 1.78475 9.5411 1.4589C9.21525 1.13306 8.77331 0.95 8.3125 0.95H6.0625C5.60169 0.95 5.15975 1.13306 4.8339 1.4589C4.50806 1.78475 4.325 2.22669 4.325 2.6875V3.8125C4.325 3.97495 4.38953 4.13074 4.5044 4.2456C4.61926 4.36047 4.77505 4.425 4.9375 4.425ZM8.825 2.6875V3.2H5.55V2.6875C5.55 2.55158 5.604 2.42122 5.70011 2.32511C5.79622 2.229 5.92658 2.175 6.0625 2.175H8.3125C8.44842 2.175 8.57878 2.229 8.67489 2.32511C8.77101 2.42122 8.825 2.55158 8.825 2.6875Z"
                  fill="#DD6262"
                  stroke="#DD6262"
                  stroke-width="0.1"
                  stroke-linecap="round"
                />
                <path
                  d="M5.6294 12.1206C5.74426 12.2355 5.90005 12.3 6.0625 12.3C6.22495 12.3 6.38074 12.2355 6.4956 12.1206C6.61047 12.0057 6.675 11.8499 6.675 11.6875V7.75C6.675 7.58755 6.61047 7.43176 6.4956 7.3169C6.38074 7.20203 6.22495 7.1375 6.0625 7.1375C5.90005 7.1375 5.74426 7.20203 5.6294 7.3169C5.51453 7.43176 5.45 7.58755 5.45 7.75V11.6875C5.45 11.8499 5.51453 12.0057 5.6294 12.1206Z"
                  fill="#DD6262"
                  stroke="#DD6262"
                  stroke-width="0.1"
                  stroke-linecap="round"
                />
                <path
                  d="M7.8794 12.1206C7.99426 12.2355 8.15006 12.3 8.3125 12.3C8.47494 12.3 8.63074 12.2355 8.7456 12.1206C8.86047 12.0057 8.925 11.8499 8.925 11.6875V7.75C8.925 7.58755 8.86047 7.43176 8.7456 7.3169C8.63074 7.20203 8.47495 7.1375 8.3125 7.1375C8.15005 7.1375 7.99426 7.20203 7.8794 7.3169C7.76453 7.43176 7.7 7.58755 7.7 7.75V11.6875C7.7 11.8499 7.76453 12.0057 7.8794 12.1206Z"
                  fill="#DD6262"
                  stroke="#DD6262"
                  stroke-width="0.1"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <template v-slot:popover>
              <div class="bill-template__actions-item-hint">
                {{ $t('bill-template.actions.delete') }}
              </div>
            </template>
          </v-popover>
        </require-access>
      </div>
    </div>
    <!-- POPUP / NOTIFICATIONS    -->
    <bill-delete-popup ref="billDeletePopup"></bill-delete-popup>
    <success-notification
      ref="templateLinkCopiedNotification"
      :text="$t('bill-template.notifications.link-copied')"
    ></success-notification>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
import BillDeletePopup from '@vue-app/components/company/bills/popup/BillDeletePopup.vue'
import BillDeletedNotification from '@vue-app/components/company/bills/popup/notification/BillDeletedNotification.vue'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'
export default {
  name: 'BillTemplate',
  components: {
    RequireAccess,
    SuccessNotification,
    BillDeletedNotification,
    BillDeletePopup,
  },
  props: {
    template: { type: Object },
    companyId: { type: [String, Number] },
  },
  data() {
    return {
      isShowActions: false,
      isMouseOver: false,
    }
  },
  methods: {
    toggleActionsList() {
      this.isShowActions = !this.isShowActions
    },

    hideActionsList() {
      this.isShowActions = false
    },

    async editBill() {
      this.isShowActions = false

      this.$router.push(
        RouteHelper.getRoute('bill-template-edit', {
          companyId: this.companyId,
          templateId: this.template.TemplateID,
        })
      )
    },

    click() {
      $emit(this, 'click')
    },

    async deleteBill() {
      this.isShowActions = false

      let isDeleteBill = await this.$refs.billDeletePopup.open()

      if (!isDeleteBill) {
        return
      }

      await CompaniesApi.deactivateBillTemplate(
        this.companyId,
        this.template.TemplateID
      )

      $emit(this, 'deleted', this.template)
    },

    async copyBillLink() {
      try {
        await navigator.clipboard.writeText(this.template.TemplateUrl)
        this.$refs.templateLinkCopiedNotification.show(1)
      } catch (err) {
        console.error('Failed to copy: ', err)
      }
    },
  },
  emits: ['deleted', 'click'],
}
</script>

<style lang="scss" scoped>
.bill-template {
  background: #ffffff;
  box-shadow: 0px 20px 30px rgba(225, 235, 253, 0.38);
  border-radius: 20px;
  display: grid;
  grid-template-columns: 44px auto auto;
  column-gap: 18px;
  align-items: center;
  padding: 26px 25px 26px 38px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

  &__icon {
    width: 44px;
    height: 44px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__name {
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #465a8b;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex-shrink: 1;
    flex-grow: 0;
    overflow: hidden;
  }

  &__actions {
    position: relative;
    margin-left: auto;
    display: flex;
    align-items: center;

    &-item {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      border-radius: 50%;

      &-wrapper {
        margin-right: 12px;

        &:last-child {
          margin-right: 0;
        }
      }

      &:last-child {
        margin-right: 0;
      }

      &--copy {
        background-color: #dbe7fd;
      }

      &--delete {
        background-color: rgba(#dd6262, 0.2);
      }

      svg {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 5px;

      &:hover {
        opacity: 0.8;
      }
    }

    &-list {
      padding: 18px 0;
      position: absolute;
      top: calc(100% + 20px);
      background: #ffffff;
      box-shadow: 0px 8px 20px rgba(225, 235, 253, 0.38);
      border-radius: 12px;
    }
  }
}
</style>

<style lang="scss">
.bill-template {
  &__actions {
    &-item {
      &-hint {
        background: #ffffff;
        border: 1px solid #f4f3fc;
        padding: 9px 15px;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #47475e;
        border-radius: 8px;
      }
    }
  }
}
</style>
